/**
 * Seleção de um dispositivo no mapa dos layouts /client e /fleet.
 *
 * BUSINESS RULE: a seleção tira o realce da cerca da seleção anterior. Sem evento, o mapa vai ao
 * veículo. Com um evento de cerca, vindo do sino, vai à cerca e desliga o acompanhamento ao vivo; ver
 * docs/notificacao-de-cerca.md.
 * BUSINESS RULE: qualquer falha ao aplicar o foco leva o mapa ao veículo.
 *
 * @param {Object} params
 * @param {Object} params.devices store de dispositivos
 * @param {number} params.deviceId dispositivo escolhido, que o chamador já conferiu que existe
 * @param {Object} [params.event] evento de cerca clicado
 * @param {Object} params.instance mapa
 * @param {Function} params.focusEventGeofence do gancho das cercas
 * @param {Function} params.clearGeofenceFocus do gancho das cercas
 * @param {Function} params.setFollow liga e desliga o acompanhamento ao vivo
 */
export const selectDeviceOnMap = ({
  devices, deviceId, event, instance, focusEventGeofence, clearGeofenceFocus, setFollow,
}) => {
  clearGeofenceFocus();
  devices.setSelected(deviceId);

  const goToDevice = () => {
    if (devices.selectedDevice.hasPosition()) {
      const {longitude, latitude} = devices.selectedDevice.currentPosition;
      instance.goTo([longitude, latitude], 18);
    }
  };

  if (!event) {
    goToDevice();
    return;
  }
  Promise.resolve()
      .then(() => focusEventGeofence(event, () => setFollow(false)))
      .catch(() => false)
      .then((focused) => focused || goToDevice());
};
